export default {
  "lastUpdated": "2026-03-27T09:29:17.299Z"
};
